import { readTextFile, writeTextFile } from "@tauri-apps/plugin-fs";
import type { Node } from "prosemirror-model";

import { parsePage, serializePage } from "@moment/api-collab/markdown";

import {
	exists,
	getDocumentFilePath,
	getPageDirPath,
	getPageFilePath,
	mkdir,
	readYamlFile,
	remove,
	writeYamlFile,
} from "~/data/filesystem";
import type { StoredPage } from "~/state/types/editors.types";

import type { DocumentMetadata } from "../types";

export const filesystemApi = {
	document: {
		metadata: {
			read: async (documentPath: string): Promise<DocumentMetadata | undefined> => {
				const filePath = await getDocumentFilePath(documentPath);

				if (!(await exists(filePath))) {
					return;
				}

				return readYamlFile<DocumentMetadata>(filePath);
			},
			write: async (documentPath: string, documentMetadata: DocumentMetadata) => {
				const filePath = await getDocumentFilePath(documentPath);

				await writeYamlFile(filePath, documentMetadata);
			},
		},

		delete: async (documentPath: string) => {
			await remove(documentPath);
		},
	},

	page: {
		contents: {
			read: async (documentPath: string, pageId: string) => {
				const pageContentsFile = await readTextFile(
					await getPageFilePath(documentPath, pageId)
				);

				// TODO: fix type returned from parsePage
				const parsed = (await parsePage(pageContentsFile)) as StoredPage;

				return parsed;
			},

			write: async (documentPath: string, pageId: string, node: Node) => {
				await mkdir(await getPageDirPath(documentPath, pageId));
				const page = serializePage(node);
				await writeTextFile(await getPageFilePath(documentPath, pageId), page);
			},
		},
	},
};
